export default {
  title: "Logros",
  description: "Sigue tu progreso de planificación de boda",
  stats: {
    pointsEarned: "Puntos obtenidos",
    completed: "Completados",
    events: "Eventos",
    level: "Nivel",
    unlimited: "Ilimitado",
    limited: "Limitado",
    pro: "Pro",
    essential: "Essential",
    free: "Gratis"
  },
  categories: {
    all: "Todos",
    events: "Eventos",
    subscription: "Suscripción",
    engagement: "Compromiso",
    social: "Social"
  },
  ui: {
    points: "puntos",
    completedOn: "Completado el",
    noAchievements: "Aún no hay logros en esta categoría.",
    loading: "Cargando...",
    error: "Error al cargar los logros"
  },
  rarity: {
    common: "Común",
    rare: "Raro",
    epic: "Épico",
    legendary: "Legendario"
  },
  achievements: {
    firstGuest: "Primer invitado",
    firstTask: "Primera tarea",
    budgetSet: "Presupuesto definido",
    firstVendor: "Primer proveedor",
    planningMaster: "Maestro de planificación",
    organized: "Organizado",
    budgetWise: "Sabio con el presupuesto",
    socialite: "Sociable",
    taskMaster: "Maestro de tareas",
    timeKeeper: "Guardián del tiempo"
  },
  titles: {
    "Premier Pas": "Primer Paso",
    "Organisateur Multi-événements": "Organizador Multi-eventos",
    "Maître des Célébrations": "Maestro de Celebraciones",
    "Légende de l'Organisation": "Leyenda de la Organización",
    "Cupide du Mariage": "Ávido de Bodas",
    "Roi de la Fête": "Rey de la Fiesta",
    "Maître des Fiançailles": "Maestro de Compromisos",
    "Spécialiste Baby Shower": "Especialista en Baby Shower",
    "Organisateur Spirituel": "Organizador Espiritual",
    "Maître de Tous les Arts": "Maestro de Todas las Artes",
    "Utilisateur Fidèle": "Usuario Leal",
    "Expert Premium": "Experto Premium",
    "Liberté Illimitée": "Libertad Ilimitada",
    "Supporter de Wedora": "Seguidor de Wedora",
    "Planificateur Assidu": "Planificador Asiduo",
    "Accro à l'Organisation": "Adicto a la Organización",
    Perfectionniste: "Perfeccionista",
    "Ambassadeur Wedora": "Embajador Wedora",
    "Ambassadeur WedBox": "Embajador WedBox",
    Mentor: "Mentor",
    "Organisateur débutant": "Organizador Principiante",
    "Organisateur confirmé": "Organizador Confirmado",
    "Maître organisateur": "Organizador Maestro",
    "Premier invité": "Primer Invitado",
    "Mariage intime": "Boda Íntima",
    "Grande célébration": "Gran Celebración",
    "Planificateur économe": "Planificador Económico",
    "Gestionnaire avisé": "Gestor Inteligente",
    "Expert financier": "Experto Financiero",
    "Chroniqueur débutant": "Cronista Principiante",
    "Maître du temps": "Maestro del Tiempo",
    "Bienvenue !": "¡Bienvenido!",
    "C'est parti !": "¡Vamos!",
    "Supporter de WedBox": "Partidario de WedBox"
  },
  descriptions: {
    firstGuest: "Agrega tu primer invitado a la lista",
    firstTask: "Crea tu primera tarea",
    budgetSet: "Establece tu presupuesto de boda",
    firstVendor: "Agrega tu primer proveedor",
    planningMaster: "Completa el 50% de tus tareas",
    organized: "Crea 10 tareas",
    budgetWise: "Mantente dentro del 90% de tu presupuesto",
    socialite: "Agrega 50 invitados",
    taskMaster: "Completa 20 tareas",
    timeKeeper: "Crea tu cronograma",
    "Créez votre premier événement": "Crea tu primer evento",
    "Gérez 3 événements différents": "Gestiona 3 eventos diferentes",
    "Créez 5 événements différents": "Crea 5 eventos diferentes",
    "Gérez 10 événements ou plus": "Gestiona 10 o más eventos",
    "Organisez votre premier mariage": "Organiza tu primera boda",
    "Organisez 3 anniversaires": "Organiza 3 cumpleaños",
    "Organisez une cérémonie de fiançailles": "Organiza una ceremonia de compromiso",
    "Organisez un baby shower": "Organiza un baby shower",
    "Organisez un baptême": "Organiza un bautismo",
    "Organisez au moins un événement de chaque type": "Organiza al menos un evento de cada tipo",
    "Passez au plan Essential": "Cambia al plan Essential",
    "Passez au plan Pro": "Cambia al plan Pro",
    "Profitez des événements illimités du plan Pro": "Disfruta de eventos ilimitados con el plan Pro",
    "Restez abonné pendant 3 mois": "Mantén la suscripción durante 3 meses",
    "Connectez-vous 7 jours consécutifs": "Inicia sesión 7 días consecutivos",
    "Connectez-vous 30 jours consécutifs": "Inicia sesión 30 días consecutivos",
    "Complétez 100% des tâches d'un événement": "Completa el 100% de las tareas de un evento",
    "Partagez votre expérience sur les réseaux sociaux": "Comparte tu experiencia en redes sociales",
    "Aidez un autre utilisateur avec vos conseils": "Ayuda a otro usuario con tus consejos",
    "Complétez 5 tâches": "Completa 5 tareas",
    "Complétez 15 tâches": "Completa 15 tareas",
    "Complétez 50 tâches": "Completa 50 tareas",
    "Ajoutez votre premier invité": "Agrega tu primer invitado",
    "Ajoutez 20 invités": "Agrega 20 invitados",
    "Ajoutez 100 invités": "Agrega 100 invitados",
    "Créez votre premier budget": "Crea tu primer presupuesto",
    "Ajoutez 5 dépenses": "Agrega 5 gastos",
    "Restez dans les limites de votre budget": "Mantente dentro de los límites de tu presupuesto",
    "Ajoutez votre premier événement au planning": "Agrega tu primer evento al cronograma",
    "Planifiez tous les événements importants": "Planifica todos los eventos importantes",
    "Créez votre compte Wedora": "Crea tu cuenta Wedora",
    "Créez votre compte WedBox": "Crea tu cuenta WedBox",
    "Complétez l'onboarding": "Completa la incorporación"
  },
  locked: "Bloqueado",
  unlocked: "Desbloqueado",
  progress: "Progreso",
  earned: "Ganado",
  rewards: {
    points: "{{points}} puntos",
    badge: "Insignia ganada",
    unlock: "Función desbloqueada"
  },
  earnedPoints: "Puntos ganados",
  pointsCount: "{{earned}} / {{total}}",
  points: "{{count}} punto",
  points_one: "{{count}} punto",
  points_other: "{{count}} puntos",
  completedAt: "Completado el {{date}}",
  continue: "Continuar",
  empty: {
    title: "Sin logros",
    description: "Aún no hay logros en esta categoría."
  }
};
